import { render, staticRenderFns } from "./report52.vue?vue&type=template&id=44ba952f&scoped=true"
import script from "./report52.vue?vue&type=script&lang=js"
export * from "./report52.vue?vue&type=script&lang=js"
import style0 from "./report52.vue?vue&type=style&index=0&id=44ba952f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ba952f",
  null
  
)

export default component.exports